// Shared status-bucket mapping for dashboard/reporting views.
// Sales/Purchase/Order each define their own status vocabulary; this
// collapses all of them into 4 consistent, colorblind-validated buckets so
// they can be compared and aggregated on one chart.
export const STATUS_BUCKETS = {
  good: { label: "Good", color: "#0ca30c" },
  warning: { label: "Pending", color: "#fab219" },
  serious: { label: "In Progress", color: "#ec835a" },
  critical: { label: "Cancelled", color: "#d03b3b" },
};

const STATUS_TO_BUCKET = {
  delivered: "good",
  closed: "good",
  received: "good",
  pending: "warning",
  quoted: "warning",
  in_progress: "serious",
  ordered: "serious",
  shipped: "serious",
  ready_for_shipment: "serious",
  in_production: "serious",
  cancelled: "critical",
};

export const bucketFor = (statusValue) => STATUS_TO_BUCKET[statusValue] || "warning";

// Categorical identity color per module (validated for CVD-safety alongside
// the status palette above) + which field on a raw record holds its status,
// since Order's record shape differs from Sales/Purchase.
export const MODULE_META = {
  sales_tracker: { label: "Sales", color: "#2a78d6", statusField: "status" },
  purchase_tracker: { label: "Purchase", color: "#4a3aa7", statusField: "status" },
  order_tracker: { label: "Order", color: "#e87ba4", statusField: "current_status" },
};
